import i18next from 'i18next'
import { initReactI18next } from 'react-i18next'

// Import all translation files
import translationEnglish from './assets/translation/english-translation.json'
import translationTraditionalChinese from './assets/translation/traditional-chinese-translation.json'
import translationSimplifiedChinese from './assets/translation/simplified-chinese-translation.json'
import translationJapanese from './assets/translation/japanese-translation.json'

const LANGUAGE_STORAGE_KEY = 'language'
const SUPPORTED_LANGUAGES = ['en', 'tw', 'cn', 'jp'] as const

function isSupportedLanguage(
  language: string | null
): language is (typeof SUPPORTED_LANGUAGES)[number] {
  return (
    language !== null &&
    (SUPPORTED_LANGUAGES as readonly string[]).includes(language)
  )
}

function getInitialLanguage() {
  const storedLanguage = localStorage.getItem(LANGUAGE_STORAGE_KEY)
  return isSupportedLanguage(storedLanguage) ? storedLanguage : 'en'
}

const resources = {
  en: {
    translation: translationEnglish,
  },
  tw: {
    translation: translationTraditionalChinese,
  },
  cn: {
    translation: translationSimplifiedChinese,
  },
  jp: {
    translation: translationJapanese,
  },
}

i18next.use(initReactI18next).init({
  resources,
  lng: getInitialLanguage(),
})

const html = document.documentElement

const LANG_CLASS_PREFIX = 'lang-' as const

const applyLanguageClass = (lng: string) => {
  // Remove any previous lang-* classes
  html.classList.forEach((cls) => {
    if (cls.startsWith(LANG_CLASS_PREFIX)) {
      html.classList.remove(cls)
    }
  })
  // Add new language class, e.g. lang-en, lang-jp
  html.classList.add(`${LANG_CLASS_PREFIX}${lng}`)
}

// Apply initial language
applyLanguageClass(i18next.language)

// Update on language change
i18next.on('languageChanged', (lng) => {
  localStorage.setItem(LANGUAGE_STORAGE_KEY, lng)
  applyLanguageClass(lng)
})

export default i18next
